import { WebApiService } from './plugins/webApiService';
import AuthPlugin from './plugins/authPlugin';
import { IUserResponse } from './plugins/authPlugin';
import AccountService from './Spirit/Admin/Services/AccountService';
import AffirmationService from './Spirit/Admin/Services/AffirmationService';
import SpeechService from './Spirit/Admin/Services/SpeechService';
import AnimationService from './Spirit/Admin/Services/AnimationService';
import BackgroundCategoryService from './Spirit/Admin/Services/BackgroundCategoryService';
import BackgroundFileService from './Spirit/Admin/Services/BackgroundFileService';
import BreathingService from './Spirit/Admin/Services/BreathingService';
import DocumentService from './Spirit/Admin/Services/DocumentService';
import InspirationService from './Spirit/Admin/Services/InspirationService';
import LanguageService from './Spirit/Admin/Services/LanguageService';
import LevelService from './Spirit/Admin/Services/LevelService';
import MeditationService from './Spirit/Admin/Services/MeditationService';
import MusicService from './Spirit/Admin/Services/MusicService';
import NotificationService from './Spirit/Admin/Services/NotificationService';
import PromoCodeService from './Spirit/Admin/Services/PromoCodeService';
import ReferralService from './Spirit/Admin/Services/ReferralService';
import ReminderService from './Spirit/Admin/Services/ReminderService';
import RewardService from './Spirit/Admin/Services/RewardService';
import SleepStoryService from './Spirit/Admin/Services/SleepStoryService';
import StatisticsService from './Spirit/Admin/Services/StatisticsService';
import UserService from './Spirit/Admin/Services/UserService';
import WsCallbacks from './WebSocketControllers/Core/WsCallbacks'

export default class apiDataSource {
	webApiService: WebApiService;
	private authPlugin: AuthPlugin;
	AccountService: AccountService;
	AffirmationService: AffirmationService;
	SpeechService: SpeechService;
	AnimationService: AnimationService;
	BackgroundCategoryService: BackgroundCategoryService;
	BackgroundFileService: BackgroundFileService;
	BreathingService: BreathingService;
	DocumentService: DocumentService;
	InspirationService: InspirationService;
	LanguageService: LanguageService;
	LevelService: LevelService;
	MeditationService: MeditationService;
	MusicService: MusicService;
	NotificationService: NotificationService;
	PromoCodeService: PromoCodeService;
	ReferralService: ReferralService;
	ReminderService: ReminderService;
	RewardService: RewardService;
	SleepStoryService: SleepStoryService;
	StatisticsService: StatisticsService;
	UserService: UserService;
	WsCallbacks: WsCallbacks;
	constructor(webApiUrl: string, cookieName: string = "Auth-Token") {
		this.webApiService = new WebApiService(webApiUrl,cookieName);
		this.AccountService = new AccountService(this.webApiService);
		this.AffirmationService = new AffirmationService(this.webApiService);
		this.SpeechService = new SpeechService(this.webApiService);
		this.AnimationService = new AnimationService(this.webApiService);
		this.BackgroundCategoryService = new BackgroundCategoryService(this.webApiService);
		this.BackgroundFileService = new BackgroundFileService(this.webApiService);
		this.BreathingService = new BreathingService(this.webApiService);
		this.DocumentService = new DocumentService(this.webApiService);
		this.InspirationService = new InspirationService(this.webApiService);
		this.LanguageService = new LanguageService(this.webApiService);
		this.LevelService = new LevelService(this.webApiService);
		this.MeditationService = new MeditationService(this.webApiService);
		this.MusicService = new MusicService(this.webApiService);
		this.NotificationService = new NotificationService(this.webApiService);
		this.PromoCodeService = new PromoCodeService(this.webApiService);
		this.ReferralService = new ReferralService(this.webApiService);
		this.ReminderService = new ReminderService(this.webApiService);
		this.RewardService = new RewardService(this.webApiService);
		this.SleepStoryService = new SleepStoryService(this.webApiService);
		this.StatisticsService = new StatisticsService(this.webApiService);
		this.UserService = new UserService(this.webApiService);
		this.WsCallbacks = new WsCallbacks(this.webApiService);
		// плагин авторизации
		this.authPlugin = new AuthPlugin(this.AccountService);
	}

	public get User(): IUserResponse {
		return this.authPlugin.User;
	}
	public get isLoggedIn(): boolean {
		return this.authPlugin.isLoggedIn;
	}
	public SetUser(user: IUserResponse) {
		this.authPlugin.setUser(user);
	}
}
